const axios = require('axios');
const qs = require('querystring');

const PAGE_SESSION_KEY = 'page_session';

// In-memory cache backed by sessionStorage so a full page reload (e.g. impersonation
// redirect) can reuse a still-valid server JWT while Turnstile re-runs in the background.
let _pageSession = readStoredPageSession();

function readStoredPageSession() {
  try {
    const stored = JSON.parse(sessionStorage.getItem(PAGE_SESSION_KEY));
    if (stored?.token && stored.expiresAt > Date.now()) {
      return stored;
    }
  } catch (_) {}
  return null;
}

function setPageSession(token, expiresAt) {
  _pageSession = { token, expiresAt };
  sessionStorage.setItem(PAGE_SESSION_KEY, JSON.stringify(_pageSession));
}

function clearPageSession() {
  _pageSession = null;
  sessionStorage.removeItem(PAGE_SESSION_KEY);
}

function getPageSession() {
  if (_pageSession?.token && _pageSession.expiresAt > Date.now()) {
    return _pageSession;
  }
  _pageSession = readStoredPageSession();
  return _pageSession;
}

// Singleton promise: concurrent requests wait on one poll loop until Turnstile completes.
let _pageSessionPromise = null;

function getOrWaitForPageSession() {
  const session = getPageSession();
  if (session?.token) {
    return Promise.resolve(session.token);
  }

  if (!_pageSessionPromise) {
    _pageSessionPromise = new Promise((resolve, reject) => {
      const start = Date.now();
      const interval = setInterval(() => {
        const s = getPageSession();
        if (s?.token) {
          clearInterval(interval);
          _pageSessionPromise = null;
          resolve(s.token);
        } else if (Date.now() - start > 10000) {
          clearInterval(interval);
          _pageSessionPromise = null;
          reject(new Error('Page session unavailable'));
        }
      }, 50);
    });
  }
  return _pageSessionPromise;
}

// Hold every outgoing request until the page session is ready, then attach the token.
// Auth routes are skipped — they bootstrap or renew the session itself.
axios.interceptors.request.use(async (axiosConfig) => {
  const isAuthRoute = axiosConfig.url && axiosConfig.url.includes('/auth/');
  if (!isAuthRoute) {
    try {
      const token = await getOrWaitForPageSession();
      axiosConfig.headers['x-page-session'] = token;
    } catch (e) {
      console.warn('Page session unavailable:', e.message);
    }
  }
  return axiosConfig;
});

const config = {
  headers: {
"access-token": localStorage.getItem('access-token'),
    'Content-Type': 'application/x-www-form-urlencoded',
    'Access-Control-Allow-Origin': true,
    crossorigin: true,
  },
};

function login(email, password) {
  const requestBody = {
    email: email,
    password: password,
  };
  console.log("req=",requestBody);
  return axios
    .post(process.env.REACT_APP_API_SERVER_HOST+'/Login', qs.stringify(requestBody), config)
    .then((response) => {
      console.log('user response=', response);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return [];
    });
}
function forgot(values) {
  const requestBody = {
    email: values.email,
  };
  return axios
    .post(process.env.REACT_APP_API_SERVER_HOST+'/forgotPassword', qs.stringify(requestBody), config)
    .then((response) => {
      console.log('user response', response);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return [];
    });
}
function allCount() {
  const user = JSON.parse(localStorage.getItem('user'));
  console.log("user=",user);
  const requestBody = { };
  console.log("req=",requestBody);
  const customConfig = {
    headers: {
"access-token": localStorage.getItem('access-token'),
      'Content-Type': 'application/x-www-form-urlencoded',
      'Access-Control-Allow-Origin': true,
      crossorigin: true,
      'access-token': user.token,
    },
  };
  return axios
    .post(process.env.REACT_APP_API_SERVER_HOST+'/getAllCount', qs.stringify(requestBody), customConfig)
    .then((response) => {
      console.log('user response=', response);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return [];
    });
}
function clientListAll() {
  const user = JSON.parse(localStorage.getItem('user'));
  console.log("user=",user);
  const requestBody = { };
  console.log("req=",requestBody);
  const customConfig = {
    headers: {
"access-token": localStorage.getItem('access-token'),
      'Content-Type': 'application/x-www-form-urlencoded',
      'Access-Control-Allow-Origin': true,
      crossorigin: true,
      'access-token': user.token,
    },
  };
  return axios
    .post(process.env.REACT_APP_API_SERVER_HOST+'/clientListAll', qs.stringify(requestBody), customConfig)
    .then((response) => {
      console.log('user response=', response);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return [];
    });
}
export { setPageSession, clearPageSession, getPageSession, getOrWaitForPageSession };

// eslint-disable-next-line
export const service = {
  login,
  forgot,
  allCount,
  clientListAll,
  setPageSession,
  clearPageSession,
  getPageSession,
  getOrWaitForPageSession,
};
